module.exports = __webpack_public_path__ + "img/add-friend.a8917506.svg";